// SQLure Theme - client JS
(function(){
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Mobile menu toggle
  const toggle = document.querySelector('.menu-toggle');
  const navLinks = document.querySelector('.nav-links');
  if (toggle && navLinks) {
    toggle.addEventListener('click', function() {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', !expanded);
      toggle.setAttribute('aria-label', expanded ? 'Open menu' : 'Close menu');
      navLinks.classList.toggle('open');
    });
    navLinks.addEventListener('click', function(e) {
      if (e.target.closest('a')) {
        toggle.setAttribute('aria-expanded', 'false');
        navLinks.classList.remove('open');
      }
    });
  }

  // Header scroll state
  const header = document.querySelector('header.site');
  if (header) {
    const onScroll = function() {
      header.classList.toggle('scrolled', window.scrollY > 10);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Scroll-reveal animations
  if (!prefersReduced && 'IntersectionObserver' in window) {
    const targets = document.querySelectorAll(
      '.section-head, .tile, .product-card, .story-inner > *, .botm .copy, .botm .visual, .social .cell, .news .inner'
    );
    const perParent = new Map();
    targets.forEach(function(el) {
      el.classList.add('reveal');
      const p = el.parentElement;
      const i = perParent.get(p) || 0;
      el.style.transitionDelay = Math.min(i * 50, 250) + 'ms';
      perParent.set(p, i + 1);
    });
    const io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    targets.forEach(function(el) { io.observe(el); });
  }

  // ---- Product page: resolve variant from selected options ----
  // (fixes: hidden id previously never updated, so the first variant was
  //  always added regardless of the color chosen)
  const productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    const optionsWrap = productForm.querySelector('[data-options]');
    const variantJsonEl = productForm.querySelector('[data-variant-json]');
    const idInput = productForm.querySelector('input[name="id"]');
    const addBtn = productForm.querySelector('[data-add-btn]');
    const priceEl = document.querySelector('[data-price]');
    const skuEl = document.querySelector('[data-sku]');
    const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

    if (optionsWrap && variantJsonEl && idInput) {
      let variants = [];
      try { variants = JSON.parse(variantJsonEl.textContent); } catch (e) {}

      const optionGroups = [...optionsWrap.querySelectorAll('[data-option-index]')]
        .sort((a, b) => a.dataset.optionIndex - b.dataset.optionIndex);

      function selectedValues() {
        return optionGroups.map(function(group) {
          const radio = group.querySelector('input[type="radio"]:checked');
          if (radio) return radio.value;
          const select = group.querySelector('select');
          return select ? select.value : null;
        });
      }

      function resolveVariant() {
        const vals = selectedValues();
        const variant = variants.find(function(v) {
          return (vals[0] == null || v.option1 === vals[0]) &&
                 (vals[1] == null || v.option2 === vals[1]) &&
                 (vals[2] == null || v.option3 === vals[2]);
        });
        if (!variant) return;

        idInput.value = variant.id;
        if (priceEl) {
          let html = '';
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            html += '<s style="color:var(--color-mute);font-weight:400;margin-right:8px">' + money.format(variant.compare_at_price / 100) + '</s>';
          }
          html += money.format(variant.price / 100);
          priceEl.innerHTML = html;
        }
        if (skuEl && variant.sku) skuEl.textContent = variant.sku;
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
        }
        // reflect chosen color next to the "Color —" legend
        optionGroups.forEach(function(group) {
          const label = group.querySelector('[data-opt-value]');
          const radio = group.querySelector('input[type="radio"]:checked');
          if (label && radio) label.textContent = radio.value;
        });
      }

      optionsWrap.addEventListener('change', resolveVariant);
      resolveVariant();
    }
  }

  // Update cart count via Shopify cart.js
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.cart-count').forEach(el => {
          el.textContent = cart.item_count > 0 ? cart.item_count : '';
        });
      })
      .catch(() => {});
  }
  updateCartCount();

  // AJAX add-to-cart on product page
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (form.matches('form[action*="/cart/add"]')) {
      e.preventDefault();
      const formData = new FormData(form);
      // internal option-radio-N fields are for variant resolution only
      [...formData.keys()].filter(k => k.indexOf('option-radio-') === 0).forEach(k => formData.delete(k));
      // empty selling_plan means one-time purchase
      if (formData.get('selling_plan') === '') formData.delete('selling_plan');
      const btn = form.querySelector('[type="submit"]');
      const original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(r => {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(item => {
          if (btn) btn.textContent = '✓ Added to cart';
          updateCartCount();
          setTimeout(() => {
            if (btn) { btn.disabled = false; btn.textContent = original; }
          }, 1800);
        })
        .catch(err => {
          if (btn) { btn.disabled = false; btn.textContent = original; }
          alert('Sorry, could not add to cart.');
        });
    }
  });
})();
